import React from 'react'
import { Card, CardContent } from '@/components/ui/card'
import { Code, ShoppingCart, Database, Unlock, TrendingUp, Clock } from 'lucide-react'

interface ApiFeaturesSectionProps {
  className?: string
}

const ApiFeaturesSection: React.FC<ApiFeaturesSectionProps> = ({ className }) => {
  const apiFeatures = [
    {
      name: "Order management",
      icon: <ShoppingCart size={20} />,
      color: "text-blue-600 dark:text-blue-400",
      bgColor: "bg-blue-50 dark:bg-blue-900/20"
    },
    {
      name: "Fundraising database",
      icon: <Database size={20} />,
      color: "text-green-600 dark:text-green-400",
      bgColor: "bg-green-50 dark:bg-green-900/20"
    },
    {
      name: "Token unlocks database",
      icon: <Unlock size={20} />,
      color: "text-purple-600 dark:text-purple-400",
      bgColor: "bg-purple-50 dark:bg-purple-900/20"
    },
    {
      name: "Portfolio tracking",
      icon: <TrendingUp size={20} />,
      color: "text-orange-600 dark:text-orange-400",
      bgColor: "bg-orange-50 dark:bg-orange-900/20"
    },
    {
      name: "Historical data access",
      icon: <Clock size={20} />,
      color: "text-indigo-600 dark:text-indigo-400",
      bgColor: "bg-indigo-50 dark:bg-indigo-900/20"
    }
  ]

  return (
    <div className={className}>
      <div className="flex items-center gap-2 mb-6">
        <Code className="text-purple-600 dark:text-purple-500" size={20} />
        <h2 className="text-xl font-semibold text-[var(--text)]">Full API Access Included</h2>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
        {apiFeatures.map((feature, index) => (
          <Card
            key={index}
            variant="elevated"
            hover
            className="group transition-all duration-300"
          >
            <CardContent className="p-5">
              <div className="flex flex-col items-center text-center space-y-3">
                <div className={`p-3 rounded-xl ${feature.bgColor} group-hover:scale-110 transition-transform duration-300`}>
                  <div className={feature.color}>
                    {feature.icon}
                  </div>
                </div>
                <span className="text-sm font-medium text-foreground leading-tight">
                  {feature.name}
                </span>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  )
}

export default ApiFeaturesSection 